// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9m-3";
export var contentContainer = "_9m-0";
export var editorContainer = "_9m-1";
export var quillInputForm = "_9m-2";
export var zoneDivider = "_9m-4";